import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import env from "./environment"
import prodGcskeys from './orsity-gcs.json';
import devGcskeys from './dev-gcs.json';

// Initialize Firebase
export const config = env.environment ==="production"? env.prodConfig: env.devConfig 
const fire = firebase.initializeApp(config);
export const gcsKeys = env.environment ==="production"? prodGcskeys: devGcskeys 
export const firestore = fire.firestore();
export const domainURL = env.environment ==="production"? "orsity.com" : env.devConfig.authDomain
export const stripe_api_key = env.environment ==="production"? env.stripeProdConfig.api_key : env.stripeDevConfig.api_key
export const ga_api_key = env.environment === "production" ?
env.gaProdConfig.api_key : env.gaDevConfig.api_key 
export const CLOUD_FUNCTION =env.environment ==="production" ? "https://us-central1-orsity-77bca.cloudfunctions.net" : "https://us-central1-awesome-67f16.cloudfunctions.net"
export const basicPlanPrice = env.basicPlanPrice
export const proPlanPrice = env.proPlanPrice
export default fire;
